module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-8-m3.9123def7.jpg";